<script setup lang="ts">
import HandwritingFeatureRow from "./HandwritingFeatureRow.vue";
import { HANDWRITING_TOOL_ENABLED } from "@/services/handwriting/featureFlag";
import StorageSection from "@/components/settings/StorageSection.vue";
import KnowMoreArticle from "@/components/settings/KnowMoreArticle.vue";
import storageInfoArticle from "@/assets/articles/storage-info.article";
import ThemeModePicker from "./ThemeModePicker.vue";
import LanguagePicker from "./LanguagePicker.vue";
//import FastModeToggler from "./FastModeToggler.vue";
import SettingsCategory from "./SettingsCategory.vue";
import DisplayItemsPicker from "./DisplayItemsPicker.vue";
import InstallAppSection from "./InstallAppSection.vue";
</script>
<template>
  <div
    class="settings-canvas offcanvas offcanvas-end bg-white"
    tabindex="-1"
    id="offcanvasSettings"
    aria-labelledby="offcanvasSettingsLabel"
  >
    <div class="offcanvas-header">
      <h4 class="offcanvas-title" id="offcanvasSettingsLabel">
        {{ $t("settings") }}
      </h4>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <div class="offcanvas-body bg-white">
      <div class="d-flex flex-column gap-5">
        <!-- PREFERENCES -->
        <SettingsCategory
          :title="$t('dashboard:settings.category.preferences.title')"
        >
          <LanguagePicker />
          <ThemeModePicker />
          <DisplayItemsPicker />
        </SettingsCategory>

        <!-- INSTALLATION DE L'APPLICATION -->
        <InstallAppSection />

        <!-- DRAWING TOOL : fond, stylet et sauvegarde automatique se règlent
             désormais dans l'outil dessin (volet Paramètres, modale Affichage) -->
        <SettingsCategory
          v-if="HANDWRITING_TOOL_ENABLED"
          :title="$t('dashboard:settings.category.drawing.title')"
        >
          <HandwritingFeatureRow />
          <!--FastModeToggler /-->
        </SettingsCategory>

        <!-- STORAGE AND BACKUP -->
        <SettingsCategory
          :title="$t('dashboard:settings.category.storage.title')"
        >
          <div class="mt-3"><StorageSection /></div>
          <div class="mt-3 pt-2">
            <KnowMoreArticle
              :article="storageInfoArticle"
              :title="$t('dashboard:settings.storage.learn-more')"
            ></KnowMoreArticle>
          </div>
        </SettingsCategory>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.settings-canvas.offcanvas.offcanvas-end {
  width: 500px !important;
}
</style>
